import PropTypes from 'prop-types';
import React from 'react';
import Style from './chatbot.scss'
import {connect} from 'react-redux';
import C_USER from '../../constants/user';
import C_SCOREBOARD from '../../constants/scoreBoard';
import Cx from 'classnames';
import CloseIcon from '../../images/icon-minimize.png'
import MenuIcon from '../../images/icon-menu.png'
import {postToBot, refreshToken} from '../../utils/helpers';

class Chatbot extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            botDisplayed: false
        };
    }

    componentDidMount() {
        this.handleJwtRefresh();
    }

    handleJwtRefresh() {
        refreshToken();
        setInterval(() => {
            refreshToken()
        }, 1800000); // every 30 minutes
    }

    toggleBot(){
        postToBot();
        this.setState({botDisplayed: !this.state.botDisplayed});
    }

    startOver(){
        document.getElementById('receiver').src = document.getElementById('receiver').src;
    }

    render() {
        let toggleClass = this.state.botDisplayed ? Style.open : '';

        return (
            <div className={Cx(Style.botContainer, toggleClass)}>
                <div className={Style.actionsWrapper} >
                    <div className={Style.menuWrapper}>
                        <img src={MenuIcon}/>
                        <div className={Style.menu}><ul><li onClick={this.startOver}>Start Over</li></ul></div>
                    </div>
                    <img src={CloseIcon} onClick={this.toggleBot.bind(this)} title='Minimize' />
                </div>
                <iframe id='receiver'  src='https://sysaid-chatbot.sysaidit.com' className={Style.botframe}></iframe>
                <div className={Style.botOpen} onClick={this.toggleBot.bind(this)}></div>
            </div>
        )
    }

}

Chatbot.propTypes = {
    userName: PropTypes.string.isRequired,
    userPhoto: PropTypes.string.isRequired,
    activeRequestsCount: PropTypes.number,
    closedRequestsCount: PropTypes.number,
    supervisedRequestsCount: PropTypes.number,
    pendingRequestsCount: PropTypes.number
};

function mapStateToProps(state) {
    return {
        userName: state.user.getIn([C_USER.USER_CALCULATED_NAME]),
        userPhoto: state.user.getIn([C_USER.USER_PHOTO]),
        activeRequestsCount: state.scoreBoard.getIn([C_SCOREBOARD.TABS, C_SCOREBOARD.MY_REQUEST_TAB, C_SCOREBOARD.ACTIVE_REQUESTS_COUNT]),
        closedRequestsCount: state.scoreBoard.getIn([C_SCOREBOARD.TABS, C_SCOREBOARD.RECENTLY_CLOSED_TAB, C_SCOREBOARD.CLOSED_REQUESTS_COUNT]),
        supervisedRequestsCount: state.scoreBoard.getIn([C_SCOREBOARD.TABS, C_SCOREBOARD.SUPERVISED_REQUESTS_TAB, C_SCOREBOARD.SUPERVISED_REQUESTS_COUNT]),
        pendingRequestsCount: state.scoreBoard.getIn([C_SCOREBOARD.TABS, C_SCOREBOARD.PENDING_MY_APPROVAL_TAB, C_SCOREBOARD.PENDING_REQUESTS_COUNT])
    }
}

export default connect(mapStateToProps)(Chatbot);


// WEBPACK FOOTER //
// ./components/chatbot/index.js